import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

const GermanyBloreCertMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          Apostille for Germany in Indiais a regionalized procedure is
          proceeding with the intervention of Apostille services in India.
          Legalization for Germany is the procedure of validating your documents
          to obtain a visa or grow your business in Germany. It is a significant
          step that needs to be performed if you have plans to travel to
          Germany. The legalization process for Germany is time-taking as it's a
          lengthening procedure. The certificate goes through several levels of
          certification until it eventually gets the MEA sticker. The Ministry
          of External Affairs is the department of the Indian government that
          issues the MEA stamp on the certificate.
        </li>
      </ul>
    </div>
  );
};

export default GermanyBloreCertMain;
